import { createInstance, enums } from '@optimizely/react-sdk';
import { getOptimizelyFeSdkKey } from './getEnv';

let optimizelyInstance: ReturnType<typeof createInstance> | null = null;

/** Lazily created Optimizely client shared by every flag the footer decides. */
export const getOptimizely = () => {
  if (!optimizelyInstance) {
    optimizelyInstance = createInstance({
      sdkKey: getOptimizelyFeSdkKey(),
      logLevel: enums.LOG_LEVEL.ERROR,
    });
  }
  return optimizelyInstance;
};
